<template>
    <div class="layout-container">
        <!-- 菜单tree -->
        <div class="layout-nav">
            <div class="doc-nav-title">
                <span>帮助文档</span>
                <a-tooltip placement="top">
                    <template slot="title">
                        <span>编辑帮助文档菜单</span>
                    </template>
                    <a-icon v-if="isDevelop"
                            type="setting"
                            class="menu-edit-icon"
                            @click="popUpdateDocDrawer" />
                </a-tooltip>
            </div>
            <div class="doc-nav-tree">
                <a-menu mode="inline"
                        style="width: 220px"
                        :defaultOpenKeys="openKeys"
                        :selected-keys="menuSelectedKeys"
                        @select="selectedMenuHandle">
                    <!-- 第一层 -->
                    <template v-for="item in menuTreeData">
                        <a-sub-menu v-if="item.children && item.children.length > 0"
                                    :key="item.id"
                                    :title="item.title">
                            <!-- 第二层 -->
                            <template v-for="subItem in item.children">
                                <a-sub-menu v-if="subItem.children && subItem.children.length > 0"
                                            :key="subItem.id"
                                            :title="subItem.title">
                                    <!-- 第三层 -->
                                    <template v-for="sub3Item in subItem.children">
                                        <a-sub-menu v-if="sub3Item.children && sub3Item.children.length > 0"
                                                    :key="sub3Item.id"
                                                    :title="sub3Item.title">

                                            <!-- 第三层 -->
                                            <template v-for="sub4Item in sub3Item.children">
                                                <a-sub-menu v-if="sub4Item.children && sub4Item.children.length > 0"
                                                            :key="sub4Item.id"
                                                            :title="sub4Item.title">
                                                    <!-- 第四层 -->
                                                    <a-menu-item v-for="sub5Item in sub4Item.children"
                                                                 :key="sub5Item.id"><span>{{sub5Item.title}}</span></a-menu-item>
                                                </a-sub-menu>
                                                <a-menu-item v-else
                                                             :key="sub4Item.id"><span>{{sub4Item.title}}</span></a-menu-item>
                                            </template>
                                        </a-sub-menu>
                                        <a-menu-item v-else
                                                     :key="sub3Item.id"><span>{{sub3Item.title}}</span></a-menu-item>
                                    </template>
                                </a-sub-menu>
                                <a-menu-item v-else
                                             :key="subItem.id"><span>{{subItem.title}}</span></a-menu-item>
                            </template>
                        </a-sub-menu>
                        <a-menu-item v-else
                                     :key="item.id"><span>{{item.title}}</span></a-menu-item>
                    </template>
                </a-menu>
            </div>
        </div>
        <!-- markdown文档 -->
        <div class="layout-content">
            <div class="custom-markdown">
                <div class="custom-breadcrumbs">
                    <div class="custom-breadcrumb">
                        <span>当前路径：</span>
                        <a-breadcrumb>
                            <a-breadcrumb-item v-for="(item,index) in breadcrumb"
                                               :key="index"><span style="font-size:14px;">{{item.title}}</span></a-breadcrumb-item>
                        </a-breadcrumb>
                    </div>
                    <div class="edit-panel"
                         v-if="isDevelop">
                        <a-button type="link"
                                  icon="edit"
                                  v-if="!isEditMode"
                                  style="font-size:14px"
                                  @click="switchEditMode(true)">编辑文档</a-button>
                        <a-button type="link"
                                  icon="save"
                                  v-if="isEditMode"
                                  style="font-size:14px"
                                  @click="saveMarkdown">保存</a-button>
                        <a-button type="link"
                                  v-if="isEditMode"
                                  icon="close"
                                  style="font-size:14px"
                                  @click="switchEditMode(false)">取消</a-button>
                    </div>
                </div>
                <div class="markdown-container"
                     :class="{'edit-markdown-container':isEditMode}">
                    <mavon-editor ref="mavonEditor"
                                  v-model="mdValue"
                                  :fontSize="'13px'"
                                  :toolbars="toolbars"
                                  :default-open="modeConfig.defaultOpen"
                                  :subfield="modeConfig.subfield"
                                  :boxShadow="modeConfig.boxShadow"
                                  :navigation="modeConfig.navigation"
                                  :toolbarsFlag="modeConfig.toolbarsFlag"
                                  :externalLink="modeConfig.externalLink" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import dbData from '@s/db/db.json'
import { Base64 } from 'js-base64'
export default {
    name: 'MainItem',
    data () {
        return {
            menuTreeData: [], // 当前帮助文档菜单
            menuSelectedKeys: [], // 选中菜单
            openKeys: [],
            breadcrumb: [],
            isDevelop: false, // 是否是开发环境
            isEditMode: false, // md是否是编辑模式
            mdValue: null, // markdown
            modeConfig: {
                defaultOpen: 'preview',
                subfield: false,
                boxShadow: false,
                toolbarsFlag: false,
                navigation: true,
                externalLink: false
            },
            toolbars: {
                bold: true, // 粗体
                italic: true, // 斜体
                header: true, // 标题
                underline: true, // 下划线
                strikethrough: true, // 中划线
                mark: true, // 标记
                superscript: true, // 上角标
                subscript: true, // 下角标
                quote: true, // 引用
                ol: true, // 有序列表
                ul: true, // 无序列表
                link: true, // 链接
                imagelink: false, // 图片链接
                code: true, // code
                table: true, // 表格
                fullscreen: false, // 全屏编辑
                readmodel: false, // 沉浸式阅读
                htmlcode: false, // 展示html源码
                help: true, // 帮助
                undo: true, // 上一步
                redo: true, // 下一步
                trash: true, // 清空
                save: false, // 保存（触发events中的save事件）
                navigation: false, // 导航目录
                alignleft: true, // 左对齐
                aligncenter: true, // 居中
                alignright: true, // 右对齐
                subfield: false, // 单双栏模式
                preview: true // 预览
            }
        }
    },
    computed: {
        restUrl () {
            return this.$store.state.restUrl
        }
    },
    created () {
        // 获取URL地址栏参数
        const getMenuId = this.$route.query.key || null
        this.isDevelop = (process.env.NODE_ENV === 'development') // 是否是开发环境
        this.menuTreeData = this.parseData()
        if (this.menuTreeData.length > 0) {
            if (getMenuId) {
                this.menuSelectedKeys.push(getMenuId)
            } else {
                this.setUrlQuery(this.menuTreeData[0].id)
                this.menuSelectedKeys.push(this.menuTreeData[0].id)
            }
            // 获取父级节点，设置菜单默认展开
            const parentNodeList = this.getBreadcrumb(this.menuTreeData, getMenuId)
            this.openKeys = parentNodeList.map(item => item.id)
            // 获取markdown数据
            this.getMarkdownText()
            // 获取当前菜单路径
            const locationPath = this.getBreadcrumb(this.menuTreeData, this.menuSelectedKeys[0])
            this.breadcrumb = locationPath.reverse()
        }
    },
    methods: {
        parseData () {
            const menu = []
            const map = {}
            const cloneData = JSON.parse(JSON.stringify(dbData.docs)).filter(item => item.title !== '基础服务')
            cloneData.forEach(m => {
                m.children = []
                map[m.id] = m // {1:菜单,2:菜单}
                if (m.parentId === '0') {
                    menu.push(m) // 如果是根 就直接push到menu中
                } else {
                    map[m.parentId] && map[m.parentId].children.push(m)
                }
            })
            return menu
        },
        getBreadcrumb (data, id) {
            const arr1 = JSON.parse(JSON.stringify(data))
            // 获取当前路径
            var temp = []
            var forFn = function (arr, id) {
                for (var i = 0; i < arr.length; i++) {
                    var item = arr[i]
                    if (item.id === id) {
                        delete item.children
                        temp.push(item)
                        forFn(arr1, item.parentId)
                        break
                    } else {
                        if (item.children) {
                            forFn(item.children, id)
                        }
                    }
                }
            }
            forFn(arr1, id)
            return temp
        },
        getMarkdownText () {
            if (this.isDevelop) {
                fetch(this.restUrl + '/doc/' + this.menuSelectedKeys[0]).then(response => response.json()).then(result => {
                    if (result.data) {
                        this.mdValue = Base64.decode(result.data)
                    } else {
                        this.mdValue = '### 请开始编辑...'
                    }
                })
            } else {
                const mdValue = dbData.maps[this.menuSelectedKeys[0]]
                if (mdValue) {
                    this.mdValue = Base64.decode(mdValue)
                } else {
                    this.mdValue = '### 请开始编辑...'
                }
            }
        },
        selectedMenuHandle (item) {
            this.menuSelectedKeys = [item.key]
            // 更新浏览器地址信息
            this.setUrlQuery(item.key)
            // 获取markdown数据
            this.getMarkdownText()
            // 获取当前菜单路径
            const locationPath = this.getBreadcrumb(this.menuTreeData, this.menuSelectedKeys[0])
            this.breadcrumb = locationPath.reverse()
        },
        setUrlQuery (key) {
            const query = this.$router.history.current.query
            const path = this.$router.history.current.path
            const newQuery = JSON.parse(JSON.stringify(query))
            newQuery.key = key
            this.$router.push({ path, query: newQuery })
        },
        popUpdateDocDrawer () {
            this.$router.push('/update')
        },
        switchEditMode (flag) {
            this.isEditMode = flag
            if (flag) {
                this.modeConfig.defaultOpen = null
                this.modeConfig.subfield = true
                this.modeConfig.toolbarsFlag = true
                this.modeConfig.navigation = false
                this.modeConfig.boxShadow = true
            } else {
                this.modeConfig.defaultOpen = 'preview'
                this.modeConfig.subfield = false
                this.modeConfig.toolbarsFlag = false
                this.modeConfig.navigation = true
                this.modeConfig.boxShadow = false
            }
        },
        saveMarkdown () {
            fetch(this.restUrl + '/doc', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: qs.stringify({
                    id: this.menuSelectedKeys[0],
                    data: Base64.encode(this.mdValue)
                })
            }).then(response => response.json()).then(result => {
                if (result.status) {
                    this.$message.success('数据保存成功！')
                }
            }).catch(err => {
                console.error(err)
            })
        }
    }
}
</script>
<style lang="less">
.doc-nav-tree {
    .ant-menu-inline {
        border-right: 0;
    }
    .ant-menu {
        background: none;
        font-size: 14px;
        .ant-menu-item {
            height: 30px;
            line-height: 30px;
            margin-bottom: 0 !important;
            font-size: 14px;
        }
        &:not(.ant-menu-horizontal) {
            .ant-menu-item-selected {
                background: none;
            }
        }
    }
    .ant-menu-submenu {
        .ant-menu-submenu-title {
            height: 30px !important;
            line-height: 30px !important;
            margin-bottom: 0 !important;
            font-size: 14px;
        }
        .ant-menu-sub {
            background: none;
            font-size: 14px;
            .ant-menu-item {
                height: 30px;
                line-height: 30px;
                margin-bottom: 0 !important;
            }
            .ant-menu-submenu-title {
                height: 30px !important;
                line-height: 30px !important;
                margin-bottom: 0 !important;
            }
        }
        .ant-menu-submenu-title {
            height: 30px !important;
            line-height: 30px !important;
            margin-bottom: 0 !important;
        }
    }
    .ant-menu-item-selected {
        background: none;
        font-weight: 600;
        &::after {
            border-right: 0 !important;
        }
    }
}
.markdown-body {
    font-family: 'PingFang SC', 'Helvetica Neue', 'Microsoft YaHei', '微软雅黑', Helvetica, 'Hiragino Sans GB', Arial,
        sans-serif;
    border: 0 !important;
    .v-show-content {
        padding: 20px 300px 20px 40px !important;
        background: none !important;
    }
    h1,
    h2,
    h3,
    h4,
    h5 {
        font-weight: 600;
    }
    h1 {
        font-size: 24px;
    }
    h2 {
        font-size: 22px;
    }
    h3 {
        font-size: 20px;
    }
    h4 {
        font-size: 18px;
    }
    h5 {
        font-size: 16px;
    }
    p {
        font-size: 15px;
        img {
            width: 95%;
        }
    }
    ul,
    ol {
        font-size: 15px;
    }
    .v-note-panel {
        width: 100%;
        .v-note-navigation-close {
            display: none !important;
        }
    }
    .v-note-navigation-wrapper {
        display: block;
        width: 240px !important;
        right: 10px !important;
        h1,
        h2,
        h3,
        h4,
        h5 {
            font-weight: 600 !important;
            margin: 5px 0 !important;
            color: #999 !important;
            strong {
                font-weight: 400 !important;
            }
            &:hover {
                color: #144480 !important;
            }
        }
        h1 {
            font-size: 16px !important;
        }
        h2 {
            font-size: 14px !important;
        }
        h3 {
            font-size: 12px !important;
        }
        h4 {
            font-size: 12px !important;
        }
        h5 {
            font-size: 12px !important;
        }
    }
}
.edit-markdown-container {
    .v-note-navigation-wrapper {
        display: none !important;
    }
    .v-show-content {
        padding: 20px 40px 20px 40px !important;
        background: none !important;
    }
}
</style>
<style lang="less" scoped>
.layout-container {
    width: 100%;
    height: 100%;
    display: flex;
    .layout-nav {
        width: 240px;
        height: 100%;
        background: #f2f5fc;
        .doc-nav-title {
            position: relative;
            width: 100%;
            height: 50px;
            font-size: 16px;
            color: #3d3f43;
            line-height: 50px;
            padding-left: 15px;
            border-bottom: 1px solid #e4e6f3;
            transition: all 0.3s;
            font-weight: 700;
            .menu-edit-icon {
                position: absolute;
                right: 15px;
                top: 18px;
                cursor: pointer;
                &:hover {
                    color: #0099d7;
                }
            }
        }
        .doc-nav-tree {
            width: 100%;
            height: calc(~'100% - 50px');
            padding: 5px 10px;
            font-size: 14px;
            overflow: hidden;
            &:hover {
                overflow-y: auto;
            }
        }
    }
    .layout-content {
        width: calc(~'100% - 240px');
        height: 100%;
        .custom-markdown {
            width: 100%;
            height: 100%;
            .custom-breadcrumbs {
                width: 100%;
                height: 50px;
                font-size: 14px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #e9e9e9;
                padding: 0 15px;
                .custom-breadcrumb {
                    width: 50%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                }
                .edit-panel {
                    width: 50%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                }
            }
            .markdown-container {
                width: 100%;
                height: calc(~'100% - 50px');
                // padding: 0 20px;
                .markdown-body {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
</style>
